import { Reveal, Chapter } from "./Reveal";
import { ArrowDown } from "lucide-react";
import { useT } from "../i18n";

const IMAGES = [
  { src: "/assets/dragonfarm.jpg", alt: "Dragon fruit farm — agricultural partner" },
  { src: "/assets/tuna.jpg", alt: "Fresh tuna — fishery partner" },
  { src: "/assets/production.png", alt: "Processing facility — supply partner" },
  { src: "/assets/container-load.png", alt: "Container loading — export logistics" },
];

const SupplyNetwork = () => {
  const t = useT();
  return (
    <section id="partners" data-testid="supply-network-section" className="border-y border-gold/10 bg-[#0B132B] py-24 lg:py-32">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:gap-20 lg:px-8">
        <div>
          <Reveal>
            <Chapter number="04" label={t.partners.label} testid="partners-chapter" />
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-8 font-display text-3xl font-semibold leading-tight text-white sm:text-4xl">
              {t.partners.title}
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-6 max-w-lg text-sm leading-relaxed text-slate-400 md:text-base">{t.partners.sub}</p>
          </Reveal>
          <div className="mt-10 flex flex-col">
            {t.partners.steps.map((step, i) => (
              <Reveal key={step} delay={0.06 * i}>
                <div data-testid={`supply-step-${i + 1}`} className="flex flex-col">
                  <div className={`flex items-center gap-4 border px-5 py-4 transition-[border-color] duration-300 ${
                    step.includes("CRESSCO") ? "border-gold/50 bg-gold/5" : "border-slate-800 bg-[#0B0E14]/60 hover:border-gold/30"
                  }`}>
                    <span className="font-mono text-[10px] tracking-[0.25em] text-gold">{String(i + 1).padStart(2, "0")}</span>
                    <span className={`font-mono text-xs uppercase tracking-[0.18em] ${step.includes("CRESSCO") ? "text-gold" : "text-slate-200"}`}>
                      {step}
                    </span>
                  </div>
                  {i < t.partners.steps.length - 1 && (
                    <span className="flex justify-center py-1 text-gold/50">
                      <ArrowDown size={13} />
                    </span>
                  )}
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.2}>
          <div className="grid h-full grid-cols-2 content-center gap-4">
            {IMAGES.map((img) => (
              <div key={img.src} className="group relative aspect-square overflow-hidden border border-slate-800">
                <img
                  src={img.src}
                  alt={img.alt}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B132B]/60 via-transparent to-transparent" />
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default SupplyNetwork;
